import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { PeriodType } from "../../../../../models/types/filter.types";
import { ViewsDatepickerDirective } from "@bitwarden/web-vault/app/directives/views-datepicker.directive";
import { TIME_DIRECTION_LATER } from "@bitwarden/web-vault/app/components/date-picker/calendar/calendar.component";
import { calculatePickerTranslateValue, isMobileScreen } from "../datepicker-utils";

@Component({
  selector: "app-future-views-datepicker",
  templateUrl: "./future-views-datepicker.component.html",
})
export class FutureViewsDatepickerComponent
  extends ViewsDatepickerDirective
  implements AfterViewChecked
{
  @ViewChild("endPicker", { read: ElementRef }) endPicker!: ElementRef;
  endPickerTranslateValue: string = "0";

  constructor(
    protected datePipe: DatePipe,
    protected elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    super(datePipe, elementRef);
  }
  protected readonly LATER = TIME_DIRECTION_LATER;

  ngAfterViewChecked() {
    // Only the To calendar can open here; while it's closed there's nothing to position.
    if (!this.showEndPicker) {
      return;
    }
    this.updateEndPickerTranslateValue();
    this.cdr.detectChanges();
  }

  /** The To calendar's filter: only dates after now. */
  getCurrentDateRangeFilter(date: Date): boolean {
    return date > new Date();
  }

  updateDate(dateRange: PeriodType) {
    this.scenarioStore.period.updateSelection(dateRange);
  }

  isMobileScreen = isMobileScreen;

  updateEndPickerTranslateValue() {
    this.endPickerTranslateValue = calculatePickerTranslateValue(
      this.endPickerTrigger,
      this.endPicker,
    );
  }
}
